<template>
<div class="main_container" v-loading="loading2" element-loading-text="拼命保存中"
  element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)">
  <!-- 选择栏 -->
  <div class="tittleDiv">
    <p class="spanflex">
      <!-- <span @click="clickspan1()" :class="span1_show ==1 ?'red':'nored'"
        style="margin-left:5px;display:inline-block;height:30px;cursor:pointer;margin-left:30px; position: relative;">
        基本信息
        <span v-show="span1_show ==1" class="redspan"></span>
      </span>
      <span @click="clickspan2()" :class="span1_show ==2 ?'red':'nored'"
        style="margin-left:25px;display:inline-block;height:30px;cursor:pointer; position: relative; ">
        地址信息
        <span v-show="span1_show ==2" class="redspan"></span>
      </span> -->
      <!-- 品牌建材-店铺主页 -->
      <span @click="clickspan4()" :class="span1_show ==4 ?'red':'nored'" class="tabTitle" v-if="newStoreType == 1">
        店铺主页 <span v-show="span1_show ==4" class="redspan"></span>
      </span>
      <!-- 装修公司-店铺主页 -->
      <span @click="zxgsDpzy()" :class="span1_show ==7 ?'red':'nored'" class="tabTitle" v-if="newStoreType == 2">
        店铺主页 <span v-show="span1_show ==7" class="redspan"></span>
      </span>
      <span @click="clickspan12()" :class="span1_show == 12 ? 'red' : 'nored'" class="tabTitle">
        店铺简介 <span v-show="span1_show == 12" class="redspan"></span>
      </span>

      <!-- <span @click="clickspan3()" :class="span1_show ==3 ?'red':'nored'" class="tabTitle" v-if="newStoreType == 1">
        提现信息 <span v-show="span1_show ==3" class="redspan"></span>
      </span> -->
      <span @click="clickspan11()" :class="span1_show ==11 ?'red':'nored'" class="tabTitleTwo">
        到店有礼 <span v-show="span1_show ==11" class="redspan"></span>
      </span>
      <span @click="clickspan6()" :class="span1_show ==6 ?'red':'nored'" class="tabTitleTwo">
        店铺视图 <span v-show="span1_show ==6" class="redspan"></span>
      </span>
      
      <!-- <span @click="clickspan10()" :class="span1_show ==10 ?'red':'nored'" class="tabTitleTwo" v-if="newStoreType == 2">
        收款设置 <span v-show="span1_show ==10" class="redspan"></span>
      </span> -->
      <!-- <span @click="zxgsKzxx()" :class="span1_show ==8 ?'red':'nored'" class="tabTitle" v-if="newStoreType == 2">
        扩展信息 <span v-show="span1_show ==8" class="redspan"></span>
      </span> -->
      <!-- <span @click="tixianxinxi()" :class="span1_show ==9 ?'red':'nored'" class="tabTitle" v-if="newStoreType == 2">
        提现信息 <span v-show="span1_show ==9" class="redspan"></span>
      </span> -->
      
    </p>
    <!-- <span class="wei" v-show="span1_show"></span>
    <span class="yi"  v-show="span2_show"></span>-->
  </div>
  <!-- 基本信息banner -->
  <div v-show="span1_show ==1" class="banner">
    <div style="margin-left:40px">
      <div>
        <div style="display:flex">
          <p style="height:100px;line-height:100px;">店铺Logo:</p>
          <el-upload class="avatar-uploader" action accept=".jpg, .png" :show-file-list="false"
            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img :src="LogoUrl1" v-if="LogoUrl1" class="avatar"
              style="margin-left:20px;margin-top:15px; border-radius: 50%"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <p style="color:#888;margin-left:70px;">建议尺寸：340*192，支持的图片格式：jpg、png。</p>
      </div>
      <el-form :model="form" ref="editForm">
        <el-form-item label="店铺名称：" prop>
          <el-input v-model="ShopName" maxlength="20" auto-complete="off"
            placeholder="请输入店铺名称，店铺名称最多20个字" style="width:439px"/>
        </el-form-item>
        <el-form-item label="主营品类：" prop>
          <span class="choice" @click="choiceBrandtype()">选择</span>
          <div v-show="isshowbrandType">
            <span style="color:#F56C6C">已选择：</span>
            <span v-for="(item,index) in brandTypeNamearr" :key="index"
              style="margin-right:5px;">{{item}}</span>
          </div>
        </el-form-item>
        <el-form-item label="主营品牌：" prop>
          <span :class="ischilick?'choice':'choice1'" @click="choiceBrand()">选择</span>
          <div v-show="isshowbrand">
            <span style="color:#F56C6C">已选择：</span>
            <span v-for="(item,index) in brandNamearr" :key="index"
              style="margin-right:5px;">{{item}}</span>
          </div>
        </el-form-item>
        <el-form-item label="营业时间：" prop>
          <el-select v-model="OpenBWeek" @change="weekchange()" placeholder style="width:120px;">
            <el-option v-for="(item,index) in weekarr1" :key="index" :value="item.Name" :label="item.Name"/>
          </el-select>
          <span style="margin:0 10px">到</span>
          <el-select v-model="OpenEWeek" @change="weekchange()" placeholder style="width:120px;">
            <el-option v-for="(item,index) in weekarr1" :key="index" :value="item.Name" :label="item.Name"/>
          </el-select>
          <!-- <el-select v-model="OpenBDay" @change="timechange()"  placeholder style="width:120px;margin-left:20px;">
            <el-option v-for="(item,index) in weekarr2" :key="index" :value="item.Name" :label="item.Name"/>
          </el-select>
          <span style="margin:0 10px">到</span>
          <el-select v-model="OpenEDay" @change="timechange()" placeholder style="width:120px;">
            <el-option v-for="(item,index) in weekarr2" :key="index" :value="item.Name" :label="item.Name"/>
          </el-select>-->
          <el-time-picker v-model="value4" @change="changetimevalue" is-range selectableRange
            value-format="HH:mm" format="HH:mm" range-separator="至"
            start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"/>
        </el-form-item>
        <!-- <el-form-item v-show="userType == 5||BbId == 1" label="回款类型：" prop>
          <el-select v-model="SettleTypeId" placeholder style="width:220px;">
            <el-option v-for="(item,index) in orderarr" :key="index"
              :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item v-show="userType == 5||BbId == 1" label="合作模式：" prop>
          <span class="choice" @click="hezuo = true">选择</span>
        </el-form-item> -->
        <el-form-item style="display:flex;width:100%" v-show="isbrandShow" label="合作模式：" >
          <el-select v-model="form.operatypeid" placeholder style="background:#fff;width:439px;">
            <el-option v-for="(item,index) in coperation" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
        <el-form-item label="合作时间：" style="display:flex;width:100%" v-show="this.form.operatypeid == 2&&isbrandShow == true">
          <el-date-picker type="daterange" v-model="value1" @change="changtime" style="width:439px;"
          value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
        </el-form-item>
        <el-form-item v-show="isbrandShow" style="display:flex;width:100%" label="回款类型：">
          <el-select v-model="SettleTypeId" placeholder style="background:#fff;width:439px;">
            <el-option v-for="(item,index) in orderarr" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="gudingdibu">
        <el-button type="danger" @click="edit()">保存</el-button>
        <el-button type="danger" @click="goback()">返回</el-button>
      </div>
    </div>
  </div>
  <!-- 扩展信息banner -->
  <!-- <extend ref="extend" @changespanshow="changespanshow" :shopinfoextend="shopinfoextend" v-show="span1_show ==3"/> -->
  <!-- 品牌建材 - 店铺主页 -->
  <Homepageppjc ref="Homepageppjc" @changespanshow="changespanshow" @loadingfun="loading"
    :shopinfo="shopinfo" v-if="span1_show ==4"/>
    <!-- 装修公司 - 店铺主页 -->
  <homepagezxgs ref="homepagezxgs" @changespanshow = "changespanshow" v-if="span1_show ==7"/>
  <ShopPage :shopinfo="shopinfo" v-show="span1_show ==6"/>
  <kzxxZxgs ref="kzxxZxgs" @changespanshow = "changespanshow"
  @isaddfun ="isaddfun" :isadd="isadd" v-show="span1_show ==8"/>
  <!-- 提现信息 -->
  <!-- <tixian ref="tixian" @changespanshow="changespanshow" v-show="span1_show == 9"/> -->
  <!-- 到店有礼 -->
  <dpjj ref="dpjj" @changespanshow="changespanshow" v-show="span1_show == 12"/>
  <!-- 到店有礼 -->
  <ddyl ref="ddyl" @changespanshow="changespanshow" v-show="span1_show == 11"/>
  <!-- 收款设置 -->
  <!-- <collectionSettings v-show="span1_show == 10" ref="collectionSettings" @changespanshow="changespanshow" /> -->

  <!-- 合作模型  -->
  <el-dialog title="设置合作模式"  :before-close="handleClose1" :center="true" :visible.sync="hezuo" width="33%">
    <el-form class="findform" :model="form" ref="editForm">
      <el-form-item style="display:flex;width:100%" label="合作模式：" :required="bloon" :show-message="bloon1">
        <el-select v-model="form.operatypeid" placeholder style="background:#fff;">
          <el-option v-for="(item,index) in coperation" :key="index" :value="item.Id" :label="item.Name"/>
        </el-select>
      </el-form-item>
      <el-form-item label="合作时间：" v-show="this.form.operatypeid == 2" prop
        :required="bloon" :show-message="bloon1" style="display:flex;width:100%">
        <el-date-picker type="daterange" v-model="value1" @change="changtime"
        value-format="yyyy-MM-dd" style="width:100%;display:flex"
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
      </el-form-item>
      <el-form-item style="display:flex;width:100%" label="回款类型：" :required="bloon" :show-message="bloon1" prop>
        <el-select  v-model="SettleTypeId" placeholder style="background:#fff;">
          <el-option v-for="(item,index) in orderarr" :key="index" :value="item.Id" :label="item.Name"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="text-align:center">
      <el-button style="border:none" @click="quxiao()">取 消</el-button>
      <el-button type="danger" style="border:none" @click="hezuo = false">确 定</el-button>
    </div>
  </el-dialog>
  <!--点击选择弹框-->
  <el-dialog :title="brandOrType == 0?'选择品牌':'选择品类'" :visible.sync="dialogVisible2"
    width="900px" :close-on-click-modal = "false" :before-close="handleClose2">
    <div class="chooseDia">
      <div class="searchLeft">
        <p style="margin-left:40px;">{{brandOrType == 0?'请选择品牌':'请选择品类'}}</p>
      </div>
      <div class="searchRight">
        <div class="searchTop">
          <span style=" cursor: pointer;" @click="chooseLetter2(item,index)"
            :class="{'changeColor':firstLetterType==index}"
            v-for="(item,index) in letterList" :key="index">{{item.name}}</span>
          <el-input v-show="brandOrType == 0" v-model="searchConpai" placeholder="请输入搜索内容">
            <template slot="append">
              <el-button @click="findinfo()">搜索</el-button>
            </template>
          </el-input>
          <el-input v-show="brandOrType == 1" v-model="searchConlei" placeholder="请输入搜索内容">
            <template slot="append">
              <el-button @click="findinfo()">搜索</el-button>
            </template>
          </el-input>
          <!-- <p>
            <el-checkbox v-model="checkedAll">不限</el-checkbox>
          </p>-->
        </div>
        <div class="searchBot" :style="typeHide?'max-height:155px':'max-height:190px'">
          <p class="Brand" style="cursor: pointer;" :class="item.checkedBrand==true?'brandColor':''"
            ref="brandName" v-for="(item,index) in brandList" :key="index"
            @click="choosedBrand(item,index)">{{item.Name}}</p>
          <div v-if="noMore" style="text-align: center;padding-top: 50px;">不好意思，未搜索到此内容</div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div style="text-align:center;">
        <el-button @click="goReturn2()">取消</el-button>
        <el-button type="danger" @click="sureChoose2()">确认</el-button>
      </div>
    </span>
  </el-dialog>
</div>
</template>
<script>
import { UploadImgForServer } from '../../api/newOss';
import { EditBBBaseInfo, SelectGoodsBrandTypeByFirstLetter, SelectBBShopDetailById } from "../../api/api";
import extend from "./userextend.vue";
// import Homepageppjc from "./Homepageppjc"; // 品牌建材 - 店铺主页
// import homepagezxgs from "../staging/homepagezxgs"; // 装修公司 - 店铺主页
import Homepageppjc from "./seeFindshop.vue"; // 品牌建材 - 店铺主页
import homepagezxgs from "./seeFindshop.vue"; // 装修公司 - 店铺主页
import ShopPage from "./ShopPage.vue";
import kzxxZxgs from "./extend.vue";
import tixian from "./tixian.vue";
import dpjj from "./dpjj.vue";
import ddyl from "./ddyl.vue";
export default {
  name: "findshop",
  data() {
    return {
      newStoreType: 1,
      isadd:true,
      isbrandShow:true,
      LogoUrl1:"",
      huikuanoptions: [],
      coperation: [
        {
          Id:0,
          Name:"请选择"
        },
        {
          Id: 1,
          Name: "按产品"
        },
        {
          Id: 2,
          Name: "按年"
        }
      ],
      hezuo: false,
      pinliearr: [],
      pinlieId: [],
      pinpaiarr: [],
      pinpaiId: [],
      value4: ["9:00", "19:00"],
      weekNum1: "",
      weekNum2: "",
      weekTime1: "",
      weekTime2: "",
      userType: "",
      BbId: "",
      loading2: false,
      isshowbrandType: false,
      isshowbrand: false,
      brandNamearr: [],
      brandTypeNamearr: [],
      shopinfoextend: "",
      shopinfo: [],
      BbId: 0,
      noMore: "",
      typeHide: "",
      Brandtypearr: [],
      typeIndex: [],
      brandIndex: [],
      ischilick: false,
      Brandarr: [],
      firstChoice: 0,
      brandOrType: 0,
      searchCon: "",
      checkedbiddingId: 0,
      brandList: [],
      checkedAll: false,
      firstLetterType: 0,
      orderId: 1,
      LogoUrl: "",
      ShopName: "",
      BrandIds: "1",
      BrandTypeIds: "1",
      OpenBWeek: "周一",
      OpenEWeek: " 周六",
      OpenBDay: "9:00",
      OpenEDay: "19:00",
      SettleTypeId: 1,
      operType: 1,
      weekId1: 1,
      weekId2: 7,
      form: {
        operatypeid: 0,
        data1: "",
        data2: "",
        huikuanid: ""
      },
      bloon1: false,
      showBdName: false,
      innerVisible: false,
      xuanze: [],
      bloon: true,
      span1_show: 4,
      outerVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      key1: "",
      checkedCities: [],
      cities: [],
      checkAll: false,
      letterList: [
        { name: "ALL" },
        { name: "A-G" },
        { name: "H-N" },
        { name: "O-T" },
        { name: "U-Z" }
      ],
      orderarr: [
        {
          Id: 1,
          Name: "7天结算"
        },
        {
          Id: 2,
          Name: "订单完成时结算"
        }
      ],
      weekarr1: [
        {
          Id: 1,
          Name: "周一"
        },
        {
          Id: 2,
          Name: "周二"
        },
        {
          Id: 3,
          Name: "周三"
        },
        {
          Id: 4,
          Name: "周四"
        },
        {
          Id: 5,
          Name: "周五"
        },
        {
          Id: 6,
          Name: "周六"
        },
        {
          Id: 7,
          Name: "周日"
        }
      ],
      weekarr2: [
        {
          Id: 1,
          Name: "00:00"
        },
        {
          Id: 2,
          Name: "00:30"
        },
        {
          Id: 3,
          Name: "01:00"
        },
        {
          Id: 4,
          Name: "01:30"
        },
        {
          Id: 5,
          Name: "02:00"
        },
        {
          Id: 6,
          Name: "02:30"
        },
        {
          Id: 7,
          Name: "03:00"
        },
        {
          Id: 8,
          Name: "03:30"
        },
        {
          Id: 9,
          Name: "04:00"
        },
        {
          Id: 10,
          Name: "04:30"
        },
        {
          Id: 11,
          Name: "05:00"
        },
        {
          Id: 12,
          Name: "05:30"
        },
        {
          Id: 13,
          Name: "06:00"
        },
        {
          Id: 14,
          Name: "06:30"
        },
        {
          Id: 15,
          Name: "07:00"
        },
        {
          Id: 16,
          Name: "07:30"
        },
        {
          Id: 17,
          Name: "08:00"
        },
        {
          Id: 18,
          Name: "08:30"
        },
        {
          Id: 19,
          Name: "09:00"
        },
        {
          Id: 20,
          Name: "09:30"
        },
        {
          Id: 21,
          Name: "10:00"
        },
        {
          Id: 22,
          Name: "10:30"
        },
        {
          Id: 23,
          Name: "11:00"
        },
        {
          Id: 24,
          Name: "11:30"
        },
        {
          Id: 25,
          Name: "12:00"
        },
        {
          Id: 26,
          Name: "12:30"
        },
        {
          Id: 27,
          Name: "13:00"
        },
        {
          Id: 28,
          Name: "13:30"
        },
        {
          Id: 29,
          Name: "14:00"
        },
        {
          Id: 30,
          Name: "14:30"
        },
        {
          Id: 31,
          Name: "15:00"
        },
        {
          Id: 32,
          Name: "15:30"
        },
        {
          Id: 33,
          Name: "16:00"
        },
        {
          Id: 34,
          Name: "16:30"
        },
        {
          Id: 35,
          Name: "17:00"
        },
        {
          Id: 36,
          Name: "17:30"
        },
        {
          Id: 37,
          Name: "18:00"
        },
        {
          Id: 38,
          Name: "18:30"
        },
        {
          Id: 39,
          Name: "19:00"
        },
        {
          Id: 40,
          Name: "19:30"
        },
        {
          Id: 41,
          Name: "20:00"
        },
        {
          Id: 42,
          Name: "20:30"
        },
        {
          Id: 43,
          Name: "21:00"
        },
        {
          Id: 44,
          Name: "21:30"
        },
        {
          Id: 45,
          Name: "22:00"
        },
        {
          Id: 46,
          Name: "22:30"
        },
        {
          Id: 47,
          Name: "23:00"
        },
        {
          Id: 48,
          Name: "23:30"
        }
      ],
      searchConlei: "",
      searchConpai: "",
      brandListother: [],
      value1:""
    };
  },
  methods: {
    isaddfun(val){
     this.isadd = val;
    },
    // 基本信息
    clickspan1() {
      this.span1_show = 1;
      if (this.$route.query.type == 1) {
        this.getinfobyId();
      }
    },
    // 地址信息
    clickspan2() {
      this.span1_show = 2;
      if (this.$route.query.type == 1) {
        this.getinfobyId();
      }
    },
    // 品牌建材 - 店铺主页
    clickspan4() {
      this.span1_show = 4;
      if (this.$route.query.type == 1) {
        // this.getinfobyId();
      }
    },
    // 装修公司 - 店铺主页
    zxgsDpzy() {
      this.span1_show = 7;
      // if(this.isadd){
      //   return false;
      // }
      // this.span1_show = 7;
      // this.$refs.homepagezxgs.init(7);
    },
    // 品牌建材 - 提现信息
    clickspan3() {
      this.span1_show = 3;
      if (this.$route.query.type == 1) {
        this.getinfobyId();
      }
    },
    // 店铺简介
    clickspan12() {
      this.span1_show = 12;
      this.$refs.dpjj.getinfobyId(12);
    },
    // 到店有礼
    clickspan11() {
      this.span1_show = 11;
      this.$refs.ddyl.getinfobyId(11);
    },
    // 品牌建材 - 店铺视图
    clickspan6() {
      this.span1_show = 6;
    },
    // 收款设置
    clickspan10() {
      this.span1_show = 10;
      this.$refs.collectionSettings.init(10);
    },
    // 装修公司 - 扩展信息
    zxgsKzxx() {
      this.span1_show = 8;
      this.$refs.kzxxZxgs.init(8);
    },
    // 装修公司 - 提现信息
    tixianxinxi() {
      this.span1_show = 9;
      this.$refs.tixian.init(9);
    },
    
    quxiao(){
      this.hezuo = false
      this.form = {
        operatypeid: 0,
        data1: "",
        data2: "",
      }
    },
    handleClose1(){
      this.hezuo = false
     this.form = {
        operatypeid: 0,
        data1: "",
        data2: "",
     }
    },
    changtime(val){
      if(val==null){
        this.form.data1 = ""
        this.form.data2 = ""
      }else{
        this.form.data1 = val[0]
        this.form.data2 = val[1]
      }
    },
    changespanshow(val) {
      this.span1_show = val;
    },
    changetimevalue() {
      this.OpenBDay = this.value4[0];
      this.OpenEDay = this.value4[1];
    },
    findinfo() {
      var obj = {
        userId: 0,
        firstLetterType: this.firstLetterType,
        brandOrType: this.brandOrType,
        key: this.brandOrType == 0 ? this.searchConpai : this.searchConlei,
        brandIdOrGoodsBrandTypeId: this.checkedbiddingId
      };
      SelectGoodsBrandTypeByFirstLetter(obj).then(data => {
        if (data.ResultCode == 1) {
          this.brandList = data.ResultObj;
          this.$nextTick(() => {
            for (var i = 0; i < this.$refs.brandName.length; i++) {
              this.$refs.brandName[i].style.color = "#606266";
              this.$refs.brandName[i].style.background = "#f0f0f0";
            }
          });
          if (this.brandOrType == 0) {
            this.$nextTick(() => {
              var arr = [];
              var arrId = [];
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.Brandarr.length; k++) {
                  if (this.brandList[i].Id == this.Brandarr[k]) {
                    //   this.Brandarr.push(String(this.brandList[i].Id));
                    // this.brandNamearr.push(this.brandList[i].Name)
                    this.$refs.brandName[i].style.color = "#fff";
                    this.$refs.brandName[i].style.background = "#F56C6C";
                    //  this.Brandarr.push(this.brandList[i].Id);
                  }
                }
              }
            });
          }
          if (this.brandOrType == 1) {
            this.$nextTick(() => {
              var arr1 = [];
              var arrId1 = [];
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.Brandtypearr.length; k++) {
                  if (this.brandList[i].Id == this.Brandtypearr[k]) {
                    //         this.Brandtypearr.push(String(this.brandList[i].Id));
                    // this.brandTypeNamearr.push(this.brandList[i].Name)
                    this.$refs.brandName[i].style.color = "#fff";
                    this.$refs.brandName[i].style.background = "#F56C6C";
                    arr1.push(this.brandList[i].Name);
                    arrId1.push(String(this.brandList[i].Id));
                  }
                }
              }
              // if( this.firstLetterType == 0){
              //  this.Brandtypearr=arrId1
              //   this.brandTypeNamearr = arr1
              // }
            });
          }
        }
      });
    },
    chooseLetter2(item, index) {
      this.checkedOther = false;
      this.searchCon = "";
      this.firstLetterType = index;
      this.letterDia();
    },
    weekchange() {
      for (var i = 0; i < this.weekarr1.length; i++) {
        if (this.weekarr1[i].Name == this.OpenEWeek) {
          this.weekNum1 = i;
        }
      }
      for (var k = 0; k < this.weekarr1.length; k++) {
        if (this.weekarr1[k].Name == this.OpenBWeek) {
          this.weekNum2 = k;
        }
      }
      if (this.weekNum1 < this.weekNum2) {
        this.$swal({
          type: "warning",
          text: "选择营业周期结束时需大于开始日期"
        });
        this.OpenEWeek = "";
      }
      // for(var i = 0;i<this.weekarr1.length;i++){
      //   if(this.weekarr1[i])
      // }
    },
    timechange() {
      for (var i = 0; i < this.weekarr2.length; i++) {
        if (this.weekarr2[i].Name == this.OpenEDay) {
          this.weekTime1 = i;
        }
      }
      for (var k = 0; k < this.weekarr2.length; k++) {
        if (this.weekarr2[k].Name == this.OpenBDay) {
          this.weekTime2 = k;
        }
      }
      if (this.weekTime1 < this.weekTime2) {
        this.$swal({
          type: "warning",
          text: "选择营业周期结束时需大于开始日期"
        });
        this.OpenEDay = "";
      }
    },
    loading(val) {
      this.loading2 = val;
    },
    goback() {
      this.$router.go(-1);
    },
    getinfo() {
      this.getinfobyId();
    },
    getBase64(imgUrl) {
      var that = this;
      window.URL = window.URL || window.webkitURL;
      var xhr = new XMLHttpRequest();
      xhr.open("get", imgUrl, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        //得到一个blob对象
        var blob = this.response;
        let oFileReader = new FileReader();
        oFileReader.onloadend = function(e) {
            var obj = {
              base64Img:e.target.result,
              uploadType:1
            }
            UploadImgForServer(obj).then(data=>{
              if(data.ResultCode == 1){
                 that.LogoUrl = data.ResultObj;
                 that.LogoUrl1 = localStorage.BaseUrl+data.ResultObj
              }
            })
          
        };
        oFileReader.readAsDataURL(blob);

        let src = window.URL.createObjectURL(blob);
      };
      xhr.send();
    },

    getinfobyId() {

      var obj = {
        bbId: localStorage.businessBbId,
        queryType: this.span1_show
      };
      SelectBBShopDetailById(obj).then(data => {
        if (data.ResultCode == 1) {
          if (this.span1_show == 1) {
            this.shopinfo = data.ResultObj;
            if (this.shopinfo.LogoUrl + "" == "null") {
              this.LogoUrl = "";
            } else {
              this.LogoUrl = this.shopinfo.LogoUrl;
              this.LogoUrl1 = this.shopinfo.LogoUrl;
              this.getBase64(this.shopinfo.LogoUrl);
            }
            this.ShopName = this.shopinfo.ShopName;
            BbModel: {
              SettleTypeId: this.SettleTypeId
            }
            this.form.operatypeid = this.shopinfo.CooperationTypeId
            this.value1 = [this.shopinfo.CoStartTime, this.shopinfo.CoEndTime]
            this.form.data1 = this.shopinfo.CoStartTime
            this.form.data2 = this.shopinfo.CoEndTime
            this.isshowbrand = true;
            this.isshowbrandType = true;
            this.Brandarr = this.shopinfo.BrandIds.split(",");
            this.pinpaiId = this.Brandarr;
            this.brandNamearr = this.shopinfo.BrandName.split(",");
            this.pinpaiarr = this.brandNamearr;
            this.Brandtypearr = [];
            // this.Brandtypearr = this.shopinfo.BrandTypeIds.split(",");
            this.Brandtypearr = this.shopinfo.BrandTypeIds.split(",").sort(
              (a, b) => {
                return a - b;
              }
            );
            if (this.Brandtypearr.length == 0) {
              this.ischilick = false;
            } else {
              this.ischilick = true;
            }
            this.pinlieId = this.Brandtypearr;
            this.OpenBWeek = this.shopinfo.OpenBWeek;
            this.brandTypeNamearr = this.shopinfo.BrandTypeName.split(",");
            this.pinliearr = this.brandTypeNamearr;
            this.OpenEWeek = this.shopinfo.OpenEWeek;

            this.OpenBDay = this.shopinfo.OpenBDay;
            this.OpenEDay = this.shopinfo.OpenEDay;
            this.value4 = [this.shopinfo.OpenBDay, this.shopinfo.OpenEDay];
            this.SettleTypeId = data.ResultObj.BbModel.SettleTypeId;
            this.$forceUpdate();
          }

          if (this.span1_show == 3) {
            this.shopinfoextend = data.ResultObj.BbModel;
            this.$refs.extend.init();
          } else if (this.span1_show == 4) {
            this.shopinfo = data.ResultObj;
            this.$refs.Homepageppjc.init();
          }
          // BrandIds: this.Brandarr.join(","),
          // BrandTypeIds: this.Brandtypearr.join(","),
          // OpenBWeek: this.OpenBWeek,
          // OpenEWeek: this.OpenEWeek,
          // OpenBDay: this.OpenBDay,
          // OpenEDay: this.OpenEDay,
        }
      });
    },
    //     left_span() {
    //   this.span1_show = 1;
    //   this.span2_show = false;
    //   // this.Configured = true;
    //   // this.notconfigured = false;
    //   this.isSetting = 1;
    //   this.pageIndex = 1;
    //   this.IsOwnBrand = 1;
    //   //  this.findBargainingGoods()
    // },
    // right_span() {
    //   this.span1_show = false;
    //   this.span2_show = true;
    //   // this.Configured = false;
    //   // this.notconfigured = true;
    //   this.isSetting = 2;
    //   this.pageIndex = 1;
    //   this.IsOwnBrand = 0
    //   // this.findBargainingGoods()
    // },

    sure() {
      this.dialogVisible1 = true;
    },
    handleCheckedCitiesChange1() {},
    handleCheckAllChange() {},
    handleAvatarSuccess() {},
    beforeAvatarUpload(file) {
      const isSize = new Promise(function(resolve, reject) {
        let width = 340;
        let height = 192;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          var that = this;
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function(e) {
            var obj = {
              base64Img:e.target.result,
              uploadType:1
            }
            UploadImgForServer(obj).then(data=>{
              if(data.ResultCode == 1){
                 that.LogoUrl = data.ResultObj;
                 that.LogoUrl1 = localStorage.BaseUrl+data.ResultObj
              }
            })
          };
          return file;
        },
        () => {
          this.$swal({
            type: "warning",
            text: "上传图片宽高尺寸应为340*192"
          });
          return Promise.reject();
        }
      );
      return isSize;
      // var that = this;
      // var reader = new FileReader();
      // reader.readAsDataURL(file);
      // reader.onload = function(e) {
      //   that.LogoUrl = e.target.result;
      // };
      // return file;
    },
    edit() {
      if (this.LogoUrl == "") {
        this.$swal({
          type: "warning",
          text: "请上传店铺logo"
        });
        return false;
      } else if (this.ShopName == "") {
        this.$swal({
          type: "warning",
          text: "请输入店铺名称"
        });
        return false;
      } else if (this.Brandtypearr.length == 0) {
        this.$swal({
          type: "warning",
          text: "请选择主营品类"
        });
        return false;
      } else if (this.Brandarr.length == 0) {
        this.$swal({
          type: "warning",
          text: "请选择主营品牌"
        });
        return false;
      }else if(this.form.operatypeid == 0){
        this.$swal({
          type: "warning",
          text: "请选择合作模式"
        })
        return false
      }else if(this.form.operatypeid == 2 && (this.form.data1 ==""||this.form.data2 == "")){
         this.$swal({
          type: "warning",
          text: "请选择合作时间"
        })
        return false
      }
      var obj = {
        BbId: localStorage.businessBbId,
        UserId: localStorage.Id,
        LogoUrl: this.LogoUrl,
        ShopName: this.ShopName,
        BrandIds: this.Brandarr.join(","),
        BrandTypeIds: this.Brandtypearr.join(","),
        OpenBWeek: this.OpenBWeek,
        OpenEWeek: this.OpenEWeek,
        OpenBDay: this.OpenBDay,
        OpenEDay: this.OpenEDay,
        BbModel: {
          SettleTypeId: this.SettleTypeId
        },
        CooperationTypeId:this.form.operatypeid,
        CoStartTime:this.form.data1,
        CoEndTime:this.form.data2,
        operType: 1
      };
      this.loading2 = true;
      EditBBBaseInfo(obj).then(data => {
        this.loading2 = false;
        if (data.ResultCode == 1) {
          //     this.LogoUrl = ""
          //   this.brandNamearr = []
          //  this.brandTypeNamearr = []
          //     this.ShopName = ""
          //     this.Brandarr = []
          //     this.Brandtypearr = []
          //     this.OpenBWeek = "周一"
          //     this.OpenEWeek = "周六"
          //     this.OpenBDay = "09:00"
          //     this.OpenEDay = "19:00"
          localStorage.businessBbId = data.ResultMsg;
          this.$swal({
            type: "success",
            text: "保存成功"
          });
          this.span1_show = 2;
        }
      });
    },

    //品牌品类
    letterDia() {
      var obj = {
        userId: 0,
        firstLetterType: this.firstLetterType,
        brandOrType: this.brandOrType,
        key: this.searchCon,
        brandIdOrGoodsBrandTypeId: this.checkedbiddingId
      };
      SelectGoodsBrandTypeByFirstLetter(obj).then(data => {
        if (data.ResultCode == 1) {
          this.brandList = data.ResultObj;
          this.$nextTick(() => {
            for (var i = 0; i < this.$refs.brandName.length; i++) {
              this.$refs.brandName[i].style.color = "#606266";
              this.$refs.brandName[i].style.background = "#f0f0f0";
            }
          });
          if (this.brandOrType == 0) {
            if (this.firstLetterType == 0) {
              this.brandListother = this.brandList;
            }
            this.$nextTick(() => {
              var arr = [];
              var arrId = [];
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.Brandarr.length; k++) {
                  if (this.brandList[i].Id == this.Brandarr[k]) {
                    //   this.Brandarr.push(String(this.brandList[i].Id));
                    // this.brandNamearr.push(this.brandList[i].Name)
                    this.$refs.brandName[i].style.color = "#fff";
                    this.$refs.brandName[i].style.background = "#F56C6C";
                    //  this.Brandarr.push(this.brandList[i].Id);
                    arr.push(this.brandList[i].Name);
                    arrId.push(String(this.brandList[i].Id));
                  }
                }
              }
              if (this.firstLetterType == 0) {
                this.brandNamearr = arr;
                this.Brandarr = arrId;
              }
            });
          }
          if (this.brandOrType == 1) {
            this.$nextTick(() => {
              var arr1 = [];
              var arrId1 = [];
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.Brandtypearr.length; k++) {
                  if (this.brandList[i].Id == this.Brandtypearr[k]) {
                    //         this.Brandtypearr.push(String(this.brandList[i].Id));
                    // this.brandTypeNamearr.push(this.brandList[i].Name)
                    this.$refs.brandName[i].style.color = "#fff";
                    this.$refs.brandName[i].style.background = "#F56C6C";
                    arr1.push(this.brandList[i].Name);
                    arrId1.push(String(this.brandList[i].Id));
                  }
                }
              }
              if (this.firstLetterType == 0) {
                this.Brandtypearr = arrId1;
                this.brandTypeNamearr = arr1;
              }
            });
          }
        }
      });
    },
    letterDia1() {
      var obj = {
        userId: 0,
        firstLetterType: this.firstLetterType,
        brandOrType: this.brandOrType,
        key: this.searchCon,
        brandIdOrGoodsBrandTypeId: this.checkedbiddingId
      };
      SelectGoodsBrandTypeByFirstLetter(obj).then(data => {
        if (data.ResultCode == 1) {
          this.brandList = data.ResultObj;
          this.$nextTick(() => {
            for (var i = 0; i < this.$refs.brandName.length; i++) {
              //  this.$refs.brandName[i].style.color = "#606266";
              // this.$refs.brandName[i].style.background = "#f0f0f0";
            }
          });
          if (this.brandOrType == 0) {
            this.$nextTick(() => {
              var arr = [];
              var arrId = [];
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.Brandarr.length; k++) {
                  if (this.brandList[i].Id == this.Brandarr[k]) {
                    //   this.Brandarr.push(String(this.brandList[i].Id));
                    // this.brandNamearr.push(this.brandList[i].Name)
                    // this.$refs.brandName[i].style.color = "#fff";
                    // this.$refs.brandName[i].style.background = "#F56C6C";
                    //  this.Brandarr.push(this.brandList[i].Id);
                    arr.push(this.brandList[i].Name);
                    arrId.push(String(this.brandList[i].Id));
                  }
                }
              }
              this.brandNamearr = arr;
              this.Brandarr = arrId;
            });
          }
          if (this.brandOrType == 1) {
            this.$nextTick(() => {
              var arr1 = [];
              var arrId1 = [];
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.Brandtypearr.length; k++) {
                  if (this.brandList[i].Id == this.Brandtypearr[k]) {
                    //         this.Brandtypearr.push(String(this.brandList[i].Id));
                    // this.brandTypeNamearr.push(this.brandList[i].Name)
                    this.$refs.brandName[i].style.color = "#fff";
                    this.$refs.brandName[i].style.background = "#F56C6C";
                    arr1.push(this.brandList[i].Name);
                    arrId1.push(String(this.brandList[i].Id));
                  }
                }
              }
              this.Brandtypearr = arrId1;
              this.brandTypeNamearr = arr1;
            });
          }
        }
      });
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    //点击品牌品类
    choosedBrand(item, index) {
      if (this.brandOrType == 0) {
        if (this.Brandarr.indexOf(String(item.Id)) > -1) {
          this.Brandarr.splice(this.Brandarr.indexOf(String(item.Id)), 1);
          this.brandIndex.splice(this.brandIndex.indexOf(index), 1);
          this.brandNamearr.splice(this.brandNamearr.indexOf(item.Name), 1);
          // this.brandOrType =1
          // this.letterDia()
          if (this.brandNamearr.length > 0) {
            this.isshowbrand = true;
          } else {
            this.isshowbrand = false;
          }
          this.$refs.brandName[index].style.color = "#606266";
          this.$refs.brandName[index].style.background = "#f0f0f0";
          this.$set(item, "checkedBrand", false);
        } else {
          this.Brandarr.push(String(item.Id));
          this.brandNamearr.push(item.Name);
          if (this.brandNamearr.length > 0) {
            this.isshowbrand = true;
          } else {
            this.isshowbrand = false;
          }
          this.brandIndex.push(index);
          this.$refs.brandName[index].style.color = "#fff";
          this.$refs.brandName[index].style.background = "#F56C6C";
        }
      } else {
        if (this.Brandtypearr.indexOf(String(item.Id)) > -1) {
          this.Brandtypearr.splice(
            this.Brandtypearr.indexOf(String(item.Id)),
            1
          );
          this.brandTypeNamearr.splice(
            this.brandTypeNamearr.indexOf(item.Name),
            1
          );
          if (this.brandTypeNamearr.length > 0) {
            this.isshowbrandType = true;
            this.ischilick = true;
          } else {
            this.isshowbrandType = false;
            this.ischilick = false;
          }
          this.typeIndex.splice(this.typeIndex.indexOf(index), 1);
          this.$refs.brandName[index].style.color = "#606266";
          this.$refs.brandName[index].style.background = "#f0f0f0";
          this.$set(item, "checkedBrand", false);
        } else {
          this.Brandtypearr.push(String(item.Id));
          this.typeIndex.push(index);
          this.brandTypeNamearr.push(item.Name);
          if (this.brandTypeNamearr.length > 0) {
            this.isshowbrandType = true;
            this.ischilick = true;
          } else {
            this.isshowbrandType = false;
            this.ischilick = false;
          }
          this.$refs.brandName[index].style.color = "#fff";
          this.$refs.brandName[index].style.background = "#F56C6C";
        }
      }
    },
    choiceBrand() {
      if (this.brandTypeNamearr.length == 0) {
        this.ischilick = false;
        return false;
      }
      this.ischilick = true;
      if (this.firstChoice == 0 || this.firstChoice == 1) {
        this.firstChoice = 1;
        this.checkedbiddingId = this.Brandtypearr.join(",");
      }
      if (this.firstChoice == 2) {
        this.checkedbiddingId = this.Brandtypearr.join(",");
      }
      this.brandOrType = 0;
      this.dialogVisible2 = true;
      this.letterDia();
    },
    choiceBrandtype() {
      if (this.firstChoice == 0 || this.firstChoice == 2) {
        this.firstChoice = 2;
        this.checkedbiddingId = 0;
      }
      if (this.firstChoice == 1) {
        this.checkedbiddingId = 0;
      }
      this.brandOrType = 1;
      this.dialogVisible2 = true;
      this.letterDia();
    },
    goReturn2() {
      this.dialogVisible2 = false;
      if (this.brandOrType == 1) {
        this.Brandtypearr = this.pinlieId;
        this.brandTypeNamearr = this.pinliearr;
        if (this.brandTypeNamearr.length == 0) {
          this.isshowbrandType = false;
        } else {
          this.isshowbrandType = true;
        }
      } else {
        this.Brandarr = this.pinpaiId;
        this.brandNamearr = this.pinpaiarr;
        if (this.brandNamearr.length == 0) {
          this.isshowbrand = false;
        } else {
          this.isshowbrand = true;
        }
      }
    },
    sureChoose2() {
      this.dialogVisible2 = false;
      this.pinlieId = this.Brandtypearr;
      this.pinpaiarr = this.brandNamearr;
      this.pinpaiId = this.Brandarr;
      this.pinliearr = this.brandTypeNamearr;
      this.searchConpai = "";
      this.searchConlei = "";
      if (this.brandOrType == 1) {
        this.checkedbiddingId = this.Brandtypearr.join(",");
        this.brandOrType = 0;
        var obj = {
          userId: 0,
          firstLetterType: 0,
          brandOrType: this.brandOrType,
          key: this.searchCon,
          brandIdOrGoodsBrandTypeId: this.checkedbiddingId
        };
        SelectGoodsBrandTypeByFirstLetter(obj).then(data => {
          if (data.ResultCode == 1) {
            this.brandList = data.ResultObj;
            this.$nextTick(() => {
              for (var i = 0; i < this.$refs.brandName.length; i++) {
                //  this.$refs.brandName[i].style.color = "#606266";
                // this.$refs.brandName[i].style.background = "#f0f0f0";
              }
            });
            if (this.brandOrType == 0) {
              this.$nextTick(() => {
                var arr = [];
                var arrId = [];
                for (var i = 0; i < this.brandList.length; i++) {
                  for (var k = 0; k < this.Brandarr.length; k++) {
                    if (this.brandList[i].Id == this.Brandarr[k]) {
                      //   this.Brandarr.push(String(this.brandList[i].Id));
                      // this.brandNamearr.push(this.brandList[i].Name)
                      // this.$refs.brandName[i].style.color = "#fff";
                      // this.$refs.brandName[i].style.background = "#F56C6C";
                      //  this.Brandarr.push(this.brandList[i].Id);
                      arr.push(this.brandList[i].Name);
                      arrId.push(String(this.brandList[i].Id));
                      if (this.brandTypeNamearr.length == 0) {
                        arr = [];
                        arrId = [];
                        this.isshowbrand = false;
                      }
                    }
                  }
                }
                this.brandNamearr = arr;
                this.Brandarr = arrId;
              });
            }
          }
        });
      } else {
        let arr = this.brandListother.filter(v =>
          this.brandNamearr.find(v2 => v2 == v.Name)
        );
        this.brandNamearr = arr.map(v => v.Name);
      }
    }
  },
  components: {
    extend,
    Homepageppjc, // 品牌建材 - 店铺主页
    homepagezxgs, // 装修公司 - 店铺主页
    ShopPage,
    kzxxZxgs, // 装修公司 - 扩展信息
    tixian, // 装修公司 - 提现信息
    // collectionSettings, // 收款设置
    dpjj, // 店铺简介
    ddyl, // 到店有礼
  },
  mounted() {
    this.newStoreType = this.$route.query.storeType; // 店铺类型
    if(this.newStoreType==2){
      this.span1_show = 7;
    }
    if(localStorage.companyId !=""){
      this.isadd = false
    }
    this.userType = localStorage.UserType;
    this.BbId = localStorage.BbId;
    // this.letterDia();
    if (this.$route.query.type == 1) {
     
      if(this.userType == 5||this.BbId==1){

        this.isbrandShow = true
      }else{

         this.isbrandShow = false
      }
      this.getinfobyId();
      // this.LogoUrl  = this.shopinfo.LogoUrl
      // this.ShopName = this.shopinfo.ShopName
      // BrandIds: this.Brandarr.join(","),
      // BrandTypeIds: this.Brandtypearr.join(","),
      // OpenBWeek: this.OpenBWeek,
      // OpenEWeek: this.OpenEWeek,
      // OpenBDay: this.OpenBDay,
      // OpenEDay: this.OpenEDay,
    }
  }
};
</script>
<style scoped lang="less">
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  cursor: pointer;
}
.spanimg {
  width: 100%;
  height: 100%;
}
.red {
  width: 80px;
  height: 100px;
  color: #F56C6C;
  text-align: center;
  line-height: 30px;
  font-size: 17px;
  font-weight: 600;
}
.redspan {
  background: #F56C6C;
  width: 130px;
  height: 2px;
  display: block;
  position: absolute;
  top: 40px;
  left: -23px;
}
.nored {
  width: 80px;
  height: 100px;
  text-align: center;
  line-height: 30px;
  font-size: 17px;
  font-weight: 500;
}
.spanflex {
  display: flex;
  justify-content: space-around;
}
.choice {
  cursor: pointer;
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.choice1 {
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: not-allowed;
}
.choice:hover {
  border-color: #F56C6C;
  color: #F56C6C;
}
.span {
  display: inline-block;
  width: 60px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #F56C6C;
  border-radius: 5px;
  margin-left: 15px;
}
.span:hover {
  background: #F56C6C;
  color: #fff;
  transform: 1s;
}
.bdname {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background: #dedede;
  margin-top: 20px;
}
.check_box {
  padding-left: 15px;
  height: 200px;
  overflow: hidden;
  overflow-y: scroll;
}
.shezhi {
  width: 80px;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}
.allchange {
  height: 35px;
  background: #f6f7f9;
  padding-left: 20px;
  margin-top: 30px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #eeeeee;
  margin-left: 20px;
  margin-top: 15px;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.chooseDia {
  width: 740px;
  height: 265px;
  background: #fff;
  border: 1px solid #f6f6f6;
  font-size: 12px;
  margin: auto;
  .searchLeft {
    float: left;
    width: 140px;
    height: 265px;
    color: #797979;
    padding-top: 30px;
    box-sizing: border-box;
    background: #f5f5f5;
    p {
      margin-bottom: 10px;
    }
  }
  .searchRight {
    width: calc(100% - 140px);
    float: right;
    height: 265px;
    overflow: hidden;
    text-align: left;
    .searchTop {
      padding: 30px 20px 15px 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #f6f6f6;
      overflow: hidden;
      span {
        margin-right: 20px;
      }
      /deep/ .el-input {
        width: 240px;
        height: 35px;
        background: #fff;
        margin-top: -10px;
        float: right;
        .el-input__inner {
          height: 35px;
          border: 1px solid #ededed;
        }
      }
      p {
        margin-top: 20px;
        /deep/ .el-input {
          float: none;
          width: 180px;
          height: 35px;
        }
      }
    }
    .searchBot {
      padding: 20px 20px 30px 20px;
      box-sizing: border-box;
      max-height: 190px;
      min-height: 155px;
      overflow-y: scroll;
      p {
        display: inline-block;
        float: left;
        padding: 8px;
        background: #f0f0f0;
        margin-right: 15px;
        margin-bottom: 15px;
      }
    }
  }
}
.changeColor {
  color: #F56C6C;
  cursor: pointer;
}
.brandColor {
  background: #F56C6C;
  color: #fff;
}
.tabTitle {
  height: 30px;
  margin-left: 25px;
  display: inline-block;
  cursor: pointer;
  position: relative;
}
.tabTitleTwo {
   height: 30px;
   margin-left: 25px;
   margin-right: 30px;
   display: inline-block;
   cursor: pointer;
   position: relative;
 }
</style>


// WEBPACK FOOTER //
// findshop.vue?2784a202